import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useServiceWorker } from '../hooks/usePWA';

const { FiRefreshCw, FiX, FiDownload } = FiIcons;

const UpdatePrompt = () => {
  const { updateAvailable, updateServiceWorker } = useServiceWorker();
  const [showPrompt, setShowPrompt] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (updateAvailable) {
      setShowPrompt(true);
    }
  }, [updateAvailable]);

  const handleUpdate = async () => {
    setIsUpdating(true);
    try {
      await updateServiceWorker();
    } catch (error) {
      console.error('Update failed:', error);
      setIsUpdating(false);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: 'spring', damping: 20 }}
      >
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl p-4 shadow-2xl border border-blue-500">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center">
              <SafeIcon icon={FiDownload} className="mr-2 text-lg" />
              <h4 className="font-semibold">Update Available</h4>
            </div>
            <button
              onClick={handleDismiss}
              className="text-blue-200 hover:text-white transition-colors"
            >
              <SafeIcon icon={FiX} />
            </button>
          </div>

          <p className="text-blue-100 text-sm mb-4">
            A new version of Angry Coder is ready! Update now to get the latest features and improvements.
          </p>

          <div className="flex gap-2">
            <button
              onClick={handleUpdate}
              disabled={isUpdating}
              className="flex-1 bg-white text-blue-600 font-medium py-2 px-4 rounded-lg hover:bg-blue-50 transition-colors duration-200 flex items-center justify-center disabled:opacity-50"
            >
              {isUpdating ? (
                <>
                  <SafeIcon icon={FiRefreshCw} className="mr-2 animate-spin" />
                  Updating...
                </>
              ) : (
                <>
                  <SafeIcon icon={FiRefreshCw} className="mr-2" />
                  Update Now
                </>
              )}
            </button>
            
            <button
              onClick={handleDismiss}
              className="px-4 py-2 text-blue-200 hover:text-white transition-colors duration-200"
            >
              Later
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UpdatePrompt;